import React, { useEffect, useState } from "react";
import Datatable from "core/pagination/datatable";
import { Link, useParams } from "react-router-dom";
import { Book, BookOpen, Edit, PlusCircle } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useTableSearch } from "core/Operations/useTableSearch";
import TableTop from "Components/UI/TableTop";
import { all_routes } from "Router/all_routes";
import { endOfMonth, format, startOfMonth } from "date-fns";
import dayjs from "dayjs";
import { DatePicker } from "antd";

import {
  useGetAuditLogListQuery,
  useGetAuditLogQuery,
} from "AppQuries/setting/aduit-log";
const { RangePicker } = DatePicker;
const disabled7DaysDate = (current, { from }) => {
  if (from) {
    return Math.abs(current.diff(from, "days")) >= 90;
  }
  return false;
};

const AuditLogDetails = () => {
  const { code } = useParams();
  const userData = useSelector(loggedInUser);

  const permissions = userData?.permissions;

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getData,
  } = useGetAuditLogQuery(
    {
      companyCode: userData?.companyCode,
      code: code,
    },
    {
      enabled: !!userData.companyCode,
    }
  );

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "auditLogId",
    },
    {
      title: "Audit Tpye",
      dataIndex: "auditTpye",
      key: "auditTpye",
    },
    {
      title: "New Description",
      dataIndex: "newDescription",
      key: "newDescription",
    },
    {
      title: "Old Description",
      dataIndex: "oldDescription",
      key: "oldDescription",
    },
    {
      title: "Audit Module",
      dataIndex: "auditModule",
      key: "auditModule",
    },
    {
      title: "Audit Time",
      dataIndex: "auditDate",
      key: "auditDate",
      // render: (text, record) => {
      //   format(new Date(text), "hh:mm A");
      // },
    },
    {
      title: "Audit User",
      dataIndex: "auditUser",
      key: "auditUser",
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(data, searchColumns);

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Audit Log</h4>
                <h6>Manage your Audit Log</h6>
              </div>
            </div>
            <div className="page-btn">
              <Link to={all_routes.audit_log} className="btn btn-secondary">
                Back
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={false}
                  />

                  <div className="table-responsive">
                    <Datatable
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                      rowKey={(record) => record.alertConfigId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditLogDetails;
